// @flow
import all from '../../intl/all';
import { createSelector } from 'reselect';

/* Action Types */
export const UPDATE = '@@intl/UPDATE';

/* reducer */
const DEFAULT_STATE = {
    locale: 'en',
    messages: all['en'],
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case UPDATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

/* SELECTORS */
const intlSelector = createSelector(
    state => state,
    s => s.intl
);

export const getLocale = createSelector(intlSelector, intl => intl.locale || 'en');

/* ACTION CREATORS */
type UpdateIntlParams = { locale: any, messages: any };
export const updateIntl = ({ locale, messages }: UpdateIntlParams) => ({
    payload: { locale, messages },
    type: UPDATE,
});

export const switchLocale = (locale: string) => async (dispatch: Function, getState: Function) => {
    try {
        dispatch(
            updateIntl({
                locale: locale,
                messages: { ...all['en'], ...all[locale] },
            })
        );
    } catch (error) {}
};
